exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label-switch {\n  float: right;\n}\n.no-bullets {\n    list-style-type: none;\n}\n.mt-2 {\n  width: 100%;\n}\n.inputFileButton {\n  float: left;\n}\n.list-block {\n    padding: 0px 0px 0px 0px;\n    margin: auto;\n    width: 100%\n}\n.button-setting {\n  width: 80px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ff75981a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/CMAddRemindSetting.vue
// module id = 1625
// module chunks = 2